export * from "./BorderedImage";
